<ol class="breadcrumb">
  <span style="margin-right:5pt">
    <a class="fa fa-home fa-fw breadcrumb-inactive"></a>
  </span>
  <li *ngFor="let breadcrumb of breadcrumbs$ | async" class="breadcrumb-item active">
    <a *ngIf="!breadcrumb.active" [routerLink]="[breadcrumb.url]" [queryParams]="[breadcrumb.params]">
      {{ getLabelBreadCrumb(breadcrumb) }}
    </a>

    <span class="active" *ngIf="breadcrumb.active"> {{ getLabelBreadCrumb(breadcrumb) }}</span>

  </li>
</ol>
